import React, {Fragment} from 'react';
import {Col, Container, Row, Button} from 'reactstrap';
import ReactMarkdown from 'react-markdown';

import {usePhaseState} from 'funnel-schedule/phase-context';
import useBalanceText from 'utils/useBalanceText';

import PageMeta from 'components/PageMeta';
import Header from 'components/Elements/Header';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import Footer from 'components/Elements/Footer';

//@ts-ignore
import {supportTeam} from 'data/pbcc-content.json';
//@ts-ignore
import {speakers} from 'data/module.json';

export default function ClarityCallsIndex() {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();

  const pageTitle = 'Office Hours';
  const pageDescription =
    'Combine in-depth plant-based nutrition education, results-driven coaching skills, and practical training to help you create greater impact and income while making a meaningful difference in the world.';
  const ogImage =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const shareUrl = 'https://certificate.foodrevolution.org/join/';
  const facebookDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const pinterestDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const pinterestImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-pin.png';

  return (
    <div className="page d-flex flex-column page-nosocial">
      <PageMeta title={pageTitle} description={pageDescription} url={shareUrl} ogImage={ogImage} />
      <div className="page-content">
        <Header
          bgColor="black"
          lockupWhite
          logoUrlOverride="https://cdn.foodrevolution.org/pbcc/pbcc-certificate-logo-white.svg"
          logoAltOverride="plant-based coaching logo"
          logoWidthOverride={300}
          logoHeightOverride={59}
          shareUrl={shareUrl}
          shareImg={ogImage}
          facebookDescription={facebookDescription}
          twitterDescription={twitterDescription}
          pinterestDescription={pinterestDescription}
          pinterestImage={pinterestImg}
        />
        <SectionCL id="pbcc-support-header" color="white" className="text-center" angle="none" order="first">
          <Container>
            <Row>
              <Col>
                <div className="background-light-gray rounded box-shadow-black-50 p-4 p-lg-5">
                  <h1 className="section-heading text-h2 mb-3">Book Your Call for Live Student Support</h1>
                  <p>Have questions about FRN’s Plant-Based Coaching Certificate Program?</p>
                  <p className="balance-text">
                    If you’ve already emailed us at{' '}
                    <a href="mailto:certificate@foodrevolution.org" target="_blank">
                      certificate@foodrevolution.org
                    </a>
                    , rest assured your message is being reviewed in the order it was received. Our team processes
                    inquiries Tuesday through Friday each week, and we appreciate your patience.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="pbcc-support-book" color="purple" order="last" angle="top" innerClass="pt-5">
          <Container>
            <Row>
              <Col>
                <div className="text-center text-white">
                  <h2 className="section-heading">Prefer to speak with someone directly?</h2>
                  <p className="balance-text text-h5">
                    When booking your call, please let us know the reason for your inquiry. This helps us connect you
                    with the best person to assist and ensures we’re fully prepared to address your needs — especially
                    if your request requires coordination with our team behind the scenes.
                  </p>
                  <h3>Our student support team</h3>
                </div>
                <Row className="d-flex align-items-stretch justify-content-center">
                  {supportTeam.map((advisor, i) => {
                    return (
                      <Fragment key={advisor + i}>
                        {speakers
                          .filter((speaker) => speaker.id === advisor.id)
                          .map((speaker) => {
                            return (
                              <Col key={speaker.id} md="6" className="d-flex flex-column flex-grow-1 mb-4 mb-md-0">
                                <div className="background-white rounded box-shadow-black-50 d-flex flex-column flex-grow-1">
                                  <div
                                    className="clarity-call-image"
                                    style={{backgroundImage: `url('${speaker.image}')`}}
                                  />
                                  <div className="clarity-call-detail p-3 flex-grow-1 d-flex flex-column">
                                    <h5 className="section-heading text-center mb-1">{speaker.name}</h5>
                                    {speaker.taglineSupportTeam && (
                                      <p className="balance-text text-center mb-0">{speaker.taglineSupportTeam}</p>
                                    )}
                                    <ReactMarkdown className="text-16 mt-3 mb-4" source={speaker.bioSupportTeam} />
                                    <p className="text-center mt-auto mb-0">
                                      <Button
                                        className="text-uppercase"
                                        color="cta mt-4"
                                        href={speaker.supportTeamLink}
                                        target="_blank"
                                        block
                                      >
                                        Book My Student Support <br className="d-none d-xl-block" />
                                        Call with {speaker.firstName}
                                      </Button>
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                      </Fragment>
                    );
                  })}
                </Row>
                <p className="text-center text-white mt-5">
                  We’re committed to providing the best support possible and look forward to assisting you!
                </p>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>
      <div className="footer-content mt-auto">
        <Footer />
      </div>
    </div>
  );
}
